<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title v-if="mode==='create'">Create Report Layout</md-dialog-title>
      <md-dialog-title v-if="mode==='update'">Edit Report Layout</md-dialog-title>

      <md-dialog-content>
        <!--<form novalidate @submit.prevent="doSave" class="shownoscroll">-->
        <form novalidate @submit.prevent="doSave">
          <calling-api type="bar" path="/api/w/layout/Save">
             <md-dialog-actions>
             <md-button class="md-primary" @click="closeDialog();showDialog = false">Close</md-button>
             <md-button type="submit" :disabled="allowupdate == false" class="md-primary buttongap">Save</md-button>
             </md-dialog-actions>
          </calling-api>

        <div id="masterData">
          <div class=" md-layout md-gutter md-alignment-center ">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <!--
            <md-field>
              <label>Layout Name</label>
              <md-input v-model="dataForm.layoutName" disabled/>
            </md-field>
          -->
            <!--
           <template v-if="create">
            <md-field>
              <label>Access Group Name</label>
              <md-input v-model="dataForm.accessGroupId"/>
            </md-field>
           </template>
           <template v-else>
            <md-field>
              <label>Access Group Name</label>
              <md-input v-model="dataForm" disabled/>
            </md-field>
           </template>
          -->
            <!--<md-field>
              <label>Access Group Description</label>
              <md-input v-model="dataForm.accessGroupDesc"/>
            </md-field>
          -->
        </div>
           <div style="margin-left:5px;">
            </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
            <md-field>
              <label>Layout Name</label>
              <md-input v-model="processname" :disabled="mode == 'update'"/>
            </md-field>
            <md-checkbox v-model="userSpecific" @change="handleUserSpecificChange">User Specific</md-checkbox>
            <md-checkbox v-if="getPermission.acnit.view || getPermission.stcMgtPWReset.edit || getPermission.fsiMgtWithRemark.edit" v-model="setDefault" @change="handleSetDefaultChange">Set Default</md-checkbox>

            <!--
           <template v-if="create">
            <auto-complete-master-data-select
                                                group="REC_WINDOW"
                                                label="Rev. Windows"
                                                :init-value="dataForm.recWindow"
                                                :on-item-changed="handleWindowsChanged"
                                                >
            </auto-complete-master-data-select>
           </template>
           <template v-else>
            <md-field>
              <label>Receive Window</label>
              <md-input v-model="dataForm.recWindow" disabled/>
            </md-field>
           </template>
          -->
               <!--<md-switch v-model="disable">Disabled</md-switch>-->
           </div>
          </div>
          <!--
          <div class=" md-layout md-gutter md-alignment-center ">
            <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <md-switch v-model="disable">Disabled</md-switch>
            </div>
          </div> 
        -->     

<!----> 
        <hr class="solidLine"/>

        <div class="selectAllSelectedCol">
          <md-checkbox v-model="selectAllSelectedCol" @change="selectedAllCol(1)">
            Select/D-Select All
          </md-checkbox>
          <div class="selectedDriverInGroupList">

          <ul>
            <li v-for="(value,key) in selectedLayoutCols" v-bind:key="key">
              <!--<md-checkbox v-model="value.selected" @change="handleSelectColChange(value.selected, key)"></md-checkbox>-->
              <md-checkbox v-model="value.selected"></md-checkbox>
                {{ value.colHeaderText }}
             </li>
            </ul>
          </div>
        </div> 
        <div class="selectAllUnSelectedCol">
          <md-checkbox v-model="selectAllUnSelectedCol" @change="selectedAllCol(2)">
            Select/D-Select All
          </md-checkbox>
          <div class="selectedDriverList">
            <ul>
              <li v-for="(value,key) in nonSelectedLayoutCols" v-bind:key="key">
                <!--<md-checkbox v-model="value.selected" @change="handleNonSelectColChange(value.selected, key)"></md-checkbox>-->
                <md-checkbox v-model="value.selected"></md-checkbox>
                {{ value.colHeaderText }}
              </li>
            </ul>

          </div>
        </div>         
          <md-button class="rightToLeft" @click="doSelectCol"><span class="icons-center material-icons"  >arrow_back</span></md-button>
          <md-button class="leftToRight" @click="doUnSelectCol"><span class="icons-center material-icons"  >arrow_forward</span></md-button>

          <!--<md-switch v-model="dataForm.active">Active</md-switch>-->
        </div>



        </form>

      </md-dialog-content>
    </md-dialog>
  </div>
</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
    height: 500px;
  }
  .fixed {
    position: fixed;
  }
  .buttongap {
    margin-left: 10px;
  }
  .shownoscroll {
    /*overflow: hidden;*/
    overflow-y: auto;
  }
  .showscroll {
    overflow: auto;
  }
  .selectedDriverList {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 250px; 
    height: 290px; 
    /*margin-left: 380px; */
    /*margin-top: -290px; */
    overflow: auto;
    
  }
  .selectedDriverInGroupList {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 250px; 
    height: 290px;
    /*margin-top: 5px;*/
    overflow: auto;
  }
  .selectAllUnSelectedCol {
    margin-left: 375px;
    margin-top: -318px; 
  }
  .selectAllSelectedCol {
    margin-top: 5px;
  }

  .rightToLeft {
    margin-top: -250px; 
    margin-left: 270px;
  }
  .leftToRight {
    margin-top: -200px; 
    margin-left: -95px;
  }
  .selectDriverInGpLabel {
    margin-top: 17px;
    margin-left: 8px;
  }
  .selectDriverInGpLabel label {
    margin-left: 10px;
    font-size: 18px;
    vertical-align: middle;
  }
  .selectDriverLabel {
    margin-left: 389px; 
    margin-top: -27px;
  }
  .selectDriverLabel label {
    margin-left: 10px;
    font-size: 18px;
    vertical-align: middle;
  }
  .txtalign {
    vertical-align: middle;
  }
  .solidLine {
    border-top: 3px solid #bbb;
  }

  ul {
    list-style-type: none;
    margin-left: 5px;
    overflow-y: hidden;
  }

  .autoscroll {
    overflow-y:auto;
  }
  
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { required, } from 'vuelidate/lib/validators';
  import DatePicker from './DatePicker.vue';
  //import AutoCompleteStcDriverGroupSelect from '../components/AutoCompleteStcDriverGroupSelect.vue';
  //import moment from 'moment';
  import PaginationListOnly from './PaginationListOnly.vue';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialDataForm = () => ({
    selected: null,
    layoutName: null,
    colDataElement: null,
    colDataType: null,
    colWidth: null,
    colHeaderText: null,
    disable: null
    //recWindow: null
  });

  const layoutstruct = () => ({
    colIndex: null,
    colHeaderText: null,
    colDataElement: null,
    colWidth: null, 
    colDataType: null,
  });

  const initSaveRequest = () => ({
    layoutList: [],
    layoutOwner: null,
    office: null,
    reportModule: null,
    layoutName: null,
    userSpecific: null,
    setDefault: null,
  });

  // const initSearchDriverGroup = () => ({
  //    seqNo: null,
  //    driverGroup: null,
  //    userName: null,
  //    driverId: null,
  //    active: true,
  //    driverName: null,
  //    recWindow: null
  // });

  // const initSearchAccessGroup = () => ({
  //     accessGroupId: null,
  //     accessGroupName: null,
  //     onlyActive: null 
  // });

  // const initSearchAccessObject = () => ({
  //     appName: null,
  //     objectName: null,
  //     objectPermission: null,
  //     onlyActive: null
  // });

  // const getInitDriverSearch = () => ({
  //    source: null,
  //    driverOffice: null,
  //    defaultSalesOffice: null
  // });

  // const getInitAccessGroupItem = () => ({
  //    selected: false,
  //    accessGroupId: null,
  //    accessGroupName: null
  // })

  // const initUpdateAccessGroup = () => ({
  //   accessGroupId: null,
  //   accessGroupName: null,
  //   accessGroupDesc: null,
  //   accessObjIds: null,
  //   disable: null
  // })

  export default {
  components: { 
     DatePicker,
     //AutoCompleteStcDriverGroupSelect, 
     PaginationListOnly
  },
    mixins: [validationMixin,
    PaginationListOnly],
    props: {
      mode: String,
      onUpdate: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialDataForm(),
      //searchAccessGroupReq: initSearchAccessGroup(),
      //searchAccessObjectReq: initSearchAccessObject(),
      //searchDriverSearchReq: getInitDriverSearch(),
      //accessGroupItem: getInitAccessGroupItem(),
      //updateAccessGroupReq: initUpdateAccessGroup(),
      create: false,
      disable: false,
      link: true,
      selectedCols: [],
      unselectedCols: [],
      nonSelectedLayoutCols: [],
      defaultallcols: [],
      selectedLayoutCols: [],
      processname: null,
      selectAllSelectedCol: false,
      selectAllUnSelectedCol: false,
      userSpecific: false,
      setDefault: false,
      processreportmodule: null,
      allowupdate: true,
      reservedLayoutName: ['DEFAULT','TM_DEFAULT_GW','TM_DEFAULT_TW'],
      //selectAllSelObjs: false,
      //stcDriverGroupOption: [],
      //accessObjectOption: [],
      //drivers: [],
      //groups: [],
      //driverInfo: [],
      //groupInfo: [],
      //driversFromParams: [],
      //driverIds: [],
      //driverNames: [],
      //driverContent: [],
      //driversinGroup: [],
      //driversnotselected: [],
      //accessobjectsnotselected: [],
      //allActiveObjects: [],
      //accessObjectIds: [],
      //accessObjectNames: [],
      //accessObjectContent: [],
      //accessObjectinGroup: [],
      //objsnotselected: []
    }),
    computed: {
      ...mapGetters([
        //'getMasterDataByGroup',
        //'getMasterDataName',
        //'getSaleOfficeMasterData',
        'getPermission',
        //'getGSTDriverMaster',
        //'getGSTDriverMaster',
        //'getAccessGroups',
        //'getAccessObjects',
      ]),
      // getDispatcherInitValue() {
      //   if (this.mode === 'create') {
      //     return null;
      //   }
      //   return `${this.dataForm.dispatcherName} (${this.dataForm.dispatcherId})`;
      // },
      // getSpecialStatusInitValue() {
      //   if (this.mode === 'create') {
      //     return null;
      //   }
      //   return `${this.dataForm.statusName} (${this.dataForm.statusId})`;
      // },
    },
    watch: {
      //getAccessObjects(val) {
      //   this.updateObjects(val);
      //},
      //getAccessGroups(val) {
      //   this.updateGroups(val);
      //}
    },
    //validations: {
    //  dataForm: {
    //    driverGroup: {
    //      required,
    //    },
        // tagId: {
        //   required,
        // },
        // tagName: {
        //   required,
        // },
    //  },
    //},
    methods: {
      //async openDialog(accessgroups, allaccessobjs, selectedObject, accessobjingroup) {
      async openDialog(in_reportmodule, name,loads,in_defaultallcols,in_userspec,in_setdefault) {
          this.initComponents();
          this.userSpecific = in_userspec;
          this.setDefault = in_setdefault;
          this.processreportmodule = in_reportmodule;
          if (this.mode == 'update')
          {
             console.log(`loads: ${JSON.stringify(loads)}`);
             if (loads != null)
             {
                //this.loadedlayout = loads;  
                //this.selectedLayoutCols = loads;
                if (loads != null && loads.length > 0)
                {
                   var selectlist = [];
                   var p_items = loads;
                   var i = 1;
                   p_items.forEach((it) => {
                      var p_layout = layoutstruct();
                      p_layout.selected = false;
                      p_layout.colIndex = i.toString();
                      p_layout.colHeaderText = it.colHeaderText;
                      p_layout.colDataElement = it.colDataElement;
                      p_layout.colWidth = it.colWidth;
                      p_layout.colDataType = it.colDataType;
                      selectlist.push(p_layout)
                     i++;
                   });
                   this.selectedLayoutCols = [];
                   this.selectedLayoutCols = selectlist;
                }
             }
             console.log(`default all cols: ${JSON.stringify(this.in_defaultallcols)}`);
             if (in_defaultallcols != null)
             {
                this.defaultallcols = in_defaultallcols;
                if (this.defaultallcols.length > 0)
                {
                   var unselectlist = [];
                   var i = 1; 
                   this.defaultallcols.forEach((it) => {
                      var checkcolheadertext = this.selectedLayoutCols.filter( inner => (inner.colHeaderText == it.colHeaderText && inner.colDataElement == it.colDataElement ));
                      if (checkcolheadertext.length <= 0)
                      {
                          //this.nonSelectedLayoutCols.push(it);
                          var p_layout = layoutstruct();
                          p_layout.selected = false;
                          p_layout.colIndex = i.toString();
                          p_layout.colHeaderText = it.colHeaderText;
                          p_layout.colDataElement = it.colDataElement;
                          p_layout.colWidth = it.colWidth;
                          p_layout.colDataType = it.colDataType;
                          unselectlist.push(p_layout)
                          i++;
                      }  
                   });
                   this.nonSelectedLayoutCols = [];
                   this.nonSelectedLayoutCols = unselectlist;
                }
             }
             //if (name == 'DEFAULT' || name == 'TM_DEFAULT_GW' || name == 'TM_DEFAULT_TW')
             if (this.reservedLayoutName.includes(name.toUpperCase()))
             {
                 this.allowupdate = false;
             }
             this.processname = name;
          }
          if (this.mode == 'create')
          {
              this.processname = '';
              console.log(`create - in_defaultallcols: ${JSON.stringify(in_defaultallcols)}`);
              if (in_defaultallcols != null && in_defaultallcols.length > 0)
              {
                 var createlist = [];
                 var p_items = in_defaultallcols;
                 var i = 1;
                 p_items.forEach((it) => {
                       //it.selected = false;
                       //this.nonSelectedLayoutCols.push(it);
                      var p_layout = layoutstruct();
                      p_layout.selected = false;
                      p_layout.colIndex = i.toString();
                      p_layout.colHeaderText = it.colHeaderText;
                      p_layout.colDataElement = it.colDataElement;
                      p_layout.colWidth = it.colWidth;
                      p_layout.colDataType = it.colDataType;
                      createlist.push(p_layout)
                     i++;
                 });
                 this.nonSelectedLayoutCols = [];
                 this.nonSelectedLayoutCols = createlist;
              }
              console.log(`processed default cols: ${JSON.stringify(this.nonSelectedLayoutCols)}`);

          }
          this.showDialog = true;
          
      },
      dotest()
      {
          this.onUpdate("test");
      },
      closeDialog()
      {
          this.showDialog = false;
      },
      handleUserSpecificChange(id)
      {
          this.userSpecific = id;
      },
      handleSetDefaultChange(id)
      {
          this.setDefault = id; 
      },
      selectedAllCol(colList)
      {
         console.log(`collist: ${colList}`);
         if (colList == 1)
         {
            if (this.selectedLayoutCols.length > 0)
            {
               var p_items = this.selectedLayoutCols;
               this.selectedLayoutCols = [];
               p_items.forEach((it) => {
                   if (this.selectAllSelectedCol == true) 
                      it.selected = true;
                   else
                      it.selected = false;  
                   this.selectedLayoutCols.push(it); 
               });
            }
         }
         if (colList == 2)
         {
            if (this.nonSelectedLayoutCols.length > 0)
            {
               var p_items = this.nonSelectedLayoutCols;
               this.nonSelectedLayoutCols = [];
               p_items.forEach((it) => {
                   if (this.selectAllUnSelectedCol == true) 
                      it.selected = true;
                   else
                      it.selected = false;  
                   this.nonSelectedLayoutCols.push(it); 
               });
            }
         }
      },
      handleSelectColChange(selected, key)
      {
          this.selectedLayoutCols[key].selected = selected;
      },
      handleNonSelectColChange(selected, key)
      {
          console.log(`selected: ${selected} key: ${key} value: ${JSON.stringify(this.nonSelectedLayoutCols[key].selected)}`)
          this.nonSelectedLayoutCols[key].selected = selected;
      },

      doSelectCol()
      {
          // var selected_items = this.nonSelectedLayoutCols.filter(it => it.selected);
          // if (selected_items != null && selected_items.length > 0)
          // {
          //     selected_items.forEach((it) => {
          //         this.selectedLayoutCols.push(it); 
          //     });
          // }
          console.log(`doselectcol`);
          // var selected_items = this.selectedLayoutCols.filter(it => it.selected);
          // if (selected_items != null && selected_items.length > 0)
          // {
          //     var p_col = selected_items.pop();
          //     if (p_col.selected)
          //     {
                  
          //     }              
          //     // selected_items.forEach((it) => {
          //     //     it.selected = false;
          //     //     this.nonSelectedLayoutCols.push(it); 
          //     // });
          // }
          var selected_cols = this.selectedLayoutCols;
          var selected_cols_length = selected_cols.length;
          //this.selectedLayoutCols = [];
          var selected_move_cols = this.nonSelectedLayoutCols.filter( it => it.selected);
          var updatelist = [];
          var updatelist1 = [];

          //remove from selected list
          var i = 1;
          this.nonSelectedLayoutCols.forEach((it) => {
               var find_item = selected_move_cols.filter(inner => inner.colHeaderText == it.colHeaderText && inner.colDataElement == it.colDataElement);
               if (find_item == null || find_item.length < 1)
               {
                  var p_layout = layoutstruct();
                  p_layout.selected = false;
                  p_layout.colIndex = i.toString();
                  p_layout.colHeaderText = it.colHeaderText;
                  p_layout.colDataElement = it.colDataElement;
                  p_layout.colWidth = it.colWidth;
                  p_layout.colDataType = it.colDataType;
                  updatelist.push(p_layout)
                  i++;
               }
          });
          this.nonSelectedLayoutCols = [];
          this.nonSelectedLayoutCols = updatelist;
          //add to unselect list
          selected_move_cols.forEach((it) => {
              var p_layout = layoutstruct();
                  p_layout.selected = false;
                  p_layout.colIndex = it.colIndex;
                  p_layout.colHeaderText = it.colHeaderText;
                  p_layout.colDataElement = it.colDataElement;
                  p_layout.colWidth = it.colWidth;
                  p_layout.colDataType = it.colDataType;
                  updatelist1.push(p_layout)

          });
          this.selectedLayoutCols = this.selectedLayoutCols.concat(updatelist1);
          this.selectAllUnSelectedCol = false;
          this.selectAllSelectedCol = false;
      },
      doUnSelectCol()
      {
          console.log(`dounselectcol`);

          var selected_move_cols = this.selectedLayoutCols.filter( it => it.selected);
          var updatelist = [];
          var updatelist1 = [];

          //remove from selected list
          var i = 1;
          this.selectedLayoutCols.forEach((it) => {
               var find_item = selected_move_cols.filter(inner => inner.colHeaderText == it.colHeaderText && inner.colDataElement == it.colDataElement);
               if (find_item == null || find_item.length < 1)
               {
                  var p_layout = layoutstruct();
                  p_layout.selected = false;
                  p_layout.colIndex = i.toString();
                  p_layout.colHeaderText = it.colHeaderText;
                  p_layout.colDataElement = it.colDataElement;
                  p_layout.colWidth = it.colWidth;
                  p_layout.colDataType = it.colDataType;
                  updatelist.push(p_layout)
                  i++;
               }
          });
          this.selectedLayoutCols = [];
          this.selectedLayoutCols = updatelist;
          //add to unselect list
          selected_move_cols.forEach((it) => {
              var p_layout = layoutstruct();
                  p_layout.selected = false;
                  p_layout.colIndex = it.colIndex;
                  p_layout.colHeaderText = it.colHeaderText;
                  p_layout.colDataElement = it.colDataElement;
                  p_layout.colWidth = it.colWidth;
                  p_layout.colDataType = it.colDataType;
                  updatelist1.push(p_layout)

          });
          this.nonSelectedLayoutCols = this.nonSelectedLayoutCols.concat(updatelist1);
          this.selectAllUnSelectedCol = false;
          this.selectAllSelectedCol = false;

      },
      async doSave()
      {
         if (this.processname == null || this.processname == '')
         {
            alert("Layout Name is required!");
            // this.$buefy.notification.open({
            //         duration: 5000,
            //         message: `Layout Name is required!`,
            //         position: 'is-top-right',
            //         type: 'is-danger',
            //         hasIcon: true
            //     });

            return;
         }
         if (this.processreportmodule == null || this.processreportmodule == '')
         {
            alert("Report Module is required!");
            // this.$buefy.notification.open({
            //         duration: 5000,
            //         message: `Layout Name is required!`,
            //         position: 'is-top-right',
            //         type: 'is-danger',
            //         hasIcon: true
            //     });

            return;
         }

         if (this.setDefault)
         {
            alert("Please be caution and it may overwrite any DEFAULT layout!!");
            // this.$buefy.notification.open({
            //         duration: 5000,
            //         message: `Please be caution and it may overwrite the DEFAULT layout!`,
            //         position: 'is-top-right',
            //         type: 'is-danger',
            //         hasIcon: true
            //     });
            
         }
         if (this.selectedLayoutCols == null || this.selectedLayoutCols.length < 1)
         {
            alert("No column is selected!");
            return;
         }
         //const reservename = ['DEFAULT','TM_DEFAULT_GW','TM_DEFAULT_TW'];
         if (this.mode == 'create' && this.reservedLayoutName.includes(this.processname.toUpperCase()))
         {
            alert(this.processname.toUpperCase() + " is Reserved NAME, please use different name!");
            return;
         }

         var processlist = [];
         var counter = 1;
         console.log(`selectedLayoutCols: ${JSON.stringify(this.selectedLayoutCols)}`);
         this.selectedLayoutCols.forEach((it) => {
              var p_col = layoutstruct();
              p_col.colIndex = counter.toString();
              p_col.colHeaderText = it.colHeaderText;
              p_col.colDataElement = it.colDataElement;
              p_col.colWidth = it.colWidth;
              p_col.colDataType = it.colDataType;
              processlist.push(p_col);
              counter++;
         });
         var req = initSaveRequest();
         req.layoutList = processlist;
         req.layoutName = this.processname.toUpperCase();
         req.userSpecific = this.userSpecific;
         req.setDefault = this.setDefault;
         req.office = 'FSI';
         //req.reportModule = "IBSLIST_INBOUND"
         req.reportModule = this.processreportmodule;
         console.log(`processlist: ${JSON.stringify(processlist)}`);
         //req.layoutOwner = 

         //await api.post('/api/w/layout/Save',req)
         await newAPIPost('/api/w/layout/Save',req)
         .then((res) => {
             this.initComponents();
             this.showDialog = false;
         });

      },
      initComponents()
      {
          this.selectAllUnSelectedCol = false;
          this.selectAllSelectedCol = false;
          this.selectedLayoutCols = [];
          this.nonSelectedLayoutCols = []; 
          this.userSpecific = false;
          this.setDefault = false;         
      },
      
    },
  };
</script>
